// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1eWbZYY5hj_landings","block":"N915iqD3AB_landings"};